//Common
import { DataGrid, Drawer, Snackbar } from "../../common/VFX-UI";

//App
import { OrganizationEmployeInvalidUploadProps } from "../../../types";
import { ColumnDescription } from "react-bootstrap-table-next";
import { MoreActionButton } from "../../common/Buttons";
import { MoreActionsMenu } from "../../common/MoreActionsMenu";
import PageHeader from "../../common/PageHeader/PageHeader";
import useIncorrectEmployee from "./hooks/useIncorrectEmployee";
import { InvalidEmployeeFormContainer } from "./InvalidEmployeeFormContainer";

const IncorrectEmployeeData: React.FC<OrganizationEmployeInvalidUploadProps> = (props) => {
  const {
    data: employees,
  } = props;

  const {
    state,
    rowEvents,
    actionColumnAnchorEl,
    toggleViewHandler,
    onShowSuccess,
    handleActionClick,
    onAddSnackbarClose,
    setActionColumnAnchorEl,
  } = useIncorrectEmployee();

  const openMenu = Boolean(actionColumnAnchorEl);

  var columns: ColumnDescription[] = [
    {
      dataField: "id",
      text: "ID",
      hidden: true,
    },
  ];

  columns = [
    ...columns,
    {
      dataField: "personnelNumber",
      text: "Personnel No.",
    },
    {
      dataField: "firstName",
      text: "Name",
      formatter: (cell: any, row: any) => {
        return `${row.lastName}, ${row.firstName}`;
      },
    },
    {
      dataField: "emailAddress",
      text: "Email Address",
    },
    {
      dataField: "reason",
      text: "Reason",
      formatter: (cell: any, row: any) => {
        return <span data-toggle="tooltip"
        title={
          row?.reason
        }>
          {row?.reason}
        </span>;
      },
    },
  ];
  

  columns = [
    ...columns,
    {
      dataField: "action",
      text: "",
      style: { width: "25px" },
      isDummyField: true,
      formatter: (cell: any, row: any) => {
        return (
        <>
          {(row?.personnelNumber) &&
            <MoreActionButton handleActionClick={(e) => handleActionClick(e)}/>
          }
        </>
        );
      },
    },
  ];

  return (
    <>
      <PageHeader>Failed Employee Uploads</PageHeader>

      <Drawer show={state.toggleView}>
        {state.toggleView && (
          <InvalidEmployeeFormContainer
            onClose={toggleViewHandler}
            onShowSuccess={onShowSuccess}
            formData={state?.formData}
          />
        )}
      </Drawer>

      <DataGrid
        columns={columns}
        data={employees}
        keyField="id"
        rowEvents={rowEvents}
        totalSize={employees?.length}
        page={1}
        pageSize={100}
        remote={true}
      />

      {actionColumnAnchorEl && (
        <MoreActionsMenu
          isOpen={openMenu}
          target={actionColumnAnchorEl}
          toggle={() => {
            setActionColumnAnchorEl(null);
          }}
          viewIconText="Edit"
          onViewClick={() => {
            toggleViewHandler();
            setActionColumnAnchorEl(null);
          }}
        />
      )}

      {state.showSuccessSnackbar && (
        <Snackbar
          open={state.showSuccessSnackbar}
          message={state.successMessage}
          handleClose={onAddSnackbarClose}
          severity="success"
        />
      )}
    </>
  );
};

export default IncorrectEmployeeData;
